<template>
  <div>
    <v-select
        id="programSelector"
        :getOptionLabel="option =>option.name"
        @input="setActiveProgram"
        :options="programs"
        :value="selectedProgram"
    ></v-select>
    <pd-button v-show="inProgress==0" v-for="expo of fullExports" v-bind:key="expo.fileId" v-bind:label="expo.label"
               :click="downloadExport"
               :datatopass="expo.fileId"></pd-button>

    <div v-show="inProgress>0" style="margin:5px; border: 1px solid #ccc;border-radius: 10px">
      <div style=" transition: all .6s cubic-bezier(0.4, 0.0, 0.2, 1);height: 10px;border-radius: 10px;background: #0334ff" :style="inProgressStyle"></div>
    </div>

  </div>


</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Button from "../components/button.vue";

export default {

  name: 'FullPPanelExport',
  props: {
    msg: String
  },
  components: {
    "pd-button": Button
  },
  computed: {
    ...mapState("fullPpanelExportStore", []),
    ...mapGetters('fullPpanelExportStore', [
      "fullExports",
      "programs",
      "selectedProgram",
      "inProgress",
      "inProgressStyle"
    ])
  },
  methods: {
    downloadExport: function (downloadId) {
      this.$store.commit('fullPpanelExportStore/download', downloadId);
    },
    setActiveProgram: function (active) {
      this.$store.commit('fullPpanelExportStore/setActiveProgram', active);
    }
  },
  async beforeCreate() {
    await this.$store.commit('fullPpanelExportStore/loadFromDb');
  }
}
</script>